// src/redux/rootReducer.js

import { combineReducers } from 'redux'
import userReducer from './user/userSlice'
import listingsReducer from './listings/listingsSlice'
import bookingReducer from './booking/bookingSlice'
import authReducer from './Auth/authSlice'
import pointsReducer from './points/pointsSlice'
import youtubeReducer from './youtube/youtubeSlice'
import userRulesReducer from './userRules/userRulesSlice'
import viewerRequestReducer from './viewerRequest/viewerRequestSlice'
import tenantReducer from './tenant/tenantSlice'
import ambassadorReducer from './ambassador/ambassadorSlice'
import paymentsReducer from './payments/paymentsSlice'
import favoritesReducer from './favorites/favoritesSlice'
import reviewsReducer from './reviews/reviewsSlice'
import statsReducer from './stats/statsSlice'

const rootReducer = combineReducers({
  user: userReducer,
  listings: listingsReducer,
  booking: bookingReducer,
  auth: authReducer,
  points: pointsReducer,
  youtube: youtubeReducer,
  userRules: userRulesReducer,
  viewerRequest: viewerRequestReducer,
  tenant: tenantReducer,
  ambassador: ambassadorReducer,
  payments: paymentsReducer,
  favorites: favoritesReducer,
  reviews: reviewsReducer,
  stats: statsReducer,
})

export default rootReducer

